import AtentionIcon from "Assets/Images/atention.svg";
import { Button } from "Components/Button";
import Select from "Components/Form/Select";
import { Modal } from "Components/Modals/Modal";
import { ModalConfirm } from "Components/Modals/ModalConfirm";
import { OptionsPartner } from "Components/ServiceForm/CartSearch/interface";
import { Box } from "styles/globalComponents";

interface ModalProductsWarningProps {
  closeModal: (modal: "unavailable" | "partnerSelect" | "alerts") => void;
  modal: {
    unavailable: boolean;
    alerts: boolean;
    partnerSelect: boolean;
  };
  handleChangePartner: (value: React.ChangeEvent<HTMLInputElement>) => void;
  cancelAddProduct: () => void;
  proceedAddProduct: () => void;
  preparation: string;
  partnerSelected: number;
  partnersOptions: OptionsPartner[];
  handleConfirmPartnerSelection: () => void;
  loadingCart: boolean;
}

export const ModalProductsWarning = ({
  closeModal,
  modal,
  handleChangePartner,
  cancelAddProduct,
  proceedAddProduct,
  preparation,
  partnerSelected,
  partnersOptions,
  handleConfirmPartnerSelection,
  loadingCart,
}: ModalProductsWarningProps) => {
  function goToTypeForm() {
    window.open("https://labiexames.typeform.com/to/ct1hTzh9");
    closeModal("unavailable");
  }

  return (
    <>
      <ModalConfirm
        modalVisible={modal.unavailable}
        modalDismiss={() => closeModal("unavailable")}
        handleClick={goToTypeForm}
        text="Adicionar"
        title="Este produto está no momento está em lista de espera, deseja adicionar o cliente a lista?"
      />

      <Modal
        isOpen={modal.alerts}
        requestClose={cancelAddProduct}
        closeOverlay
        modalIcon={AtentionIcon}
        renderHeading={() => <h2>Alerta</h2>}
        renderDescription={() => <p>{preparation}</p>}
        renderActions={() => (
          <Box>
            <Box display="flex" justify="center" mt="30">
              <Button minHeight="40px" onClick={proceedAddProduct}>
                Adicionar produto
              </Button>

              <Button minHeight="40px" outlined onClick={cancelAddProduct}>
                Cancelar adição do produto
              </Button>
            </Box>
          </Box>
        )}
      />

      <Modal
        isOpen={modal.partnerSelect}
        requestClose={() => closeModal("partnerSelect")}
        closeOverlay
        modalIcon={AtentionIcon}
        renderHeading={() => <h2>Selecione o parceiro.</h2>}
        renderActions={() => (
          <Box>
            {/* @ts-ignore */}
            <Select
              label="Parceiro"
              id="type"
              value={partnerSelected}
              onChange={(value: React.ChangeEvent<HTMLInputElement>) =>
                handleChangePartner(value)
              }
              options={partnersOptions}
            />
            <Box display="flex" justify="center" mt="30">
              <Button
                onClick={handleConfirmPartnerSelection}
                loading={loadingCart}
              >
                Confirmar
              </Button>
            </Box>
          </Box>
        )}
      />
    </>
  );
};
